import React, { useEffect, useState, useCallback, Fragment, useMemo } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  LocalService,
  SubscriptionService,
  notifySubscriptionChanged,
} from '../../../../core/services';
// For subscription payment
// import useRazorpay from 'react-razorpay';
import { SubscriptionDetail } from '../../../../redux/action';
import { makeBrandSubscriptionPayment, makeRazorpayAutoPay, makeRazorpayPayment } from "../../../../core/services/PaymentService";
// To render common pricing plan compoent
import PricingPlan from './pricing-plan';
// To render basic plan data
import { SubscriptionBasicPlanData } from './subscription-plan-data';
import * as gtUtil from '../../../../core/utility'
import { useIsUSInfluencer } from '../../../../hooks/useIsUSInfluencer';

// OLD: // const localService: LocalService = new LocalService();
// Re-enabled: the free-trial claim needs toasts for its success/blocked results.
const localService: LocalService = new LocalService();
const subscriptionService: SubscriptionService = new SubscriptionService();

interface Props {
  UserReducer: any;
  SubscriptionDetail: (data: any) => void;
}

const UserSubscription: React.FC<Props> = (props: Props) => {
  // const [razorpay] = useRazorpay();
  const [availablePlan, setAvailablePlan] = useState<any>(null);
  const [activePlan, setActivePlan] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [planType, setPlanType] = useState('');
  const navigate = useNavigate();
  const [loadingPlanId, setLoadingPlanId] = useState<number | null>(null);
  const [trialLoading, setTrialLoading] = useState(false);
  // Coupons are INR / yearly-plan specific → hide the input for US influencers.
  const isUSInfluencer = useIsUSInfluencer();


  // To fetch the basic plan details
  const basicPlan: any = ['Influencer', 'Talent Partner'].includes(props?.UserReducer?.account_type) ? SubscriptionBasicPlanData.influencer : SubscriptionBasicPlanData.brand

  const handlePlanType = (tab: string) => {
    setPlanType(tab);
  }

  const getSubscriptionDetail = useCallback(() => {
    //get Subscription Plan Detail
    const { user_id, account_id, account_type, influencer_id } = props.UserReducer;
    async function getSubs() {
      try {
        const response = await subscriptionService.getPlanDetails({
          user_id: user_id,
          account_id: account_id,
          user_type: account_type,
          influencer_id: influencer_id,
        });
        if (response.status === gtUtil.Constants.SUCCESS) {
          //return Only Active Plan Info
          setAvailablePlan(response.data.rows);
          setPlanType(response.data.rows[0].plan_type);
        } else {
          // localService.toastify(response.data.status.message, 'info', 1000);
          setAvailablePlan(null);
        }

        //update subscription Details
        const getPlanDetails: any =
          await subscriptionService.getSubscription_Remaining_Days({
            account_id: props.UserReducer.account_id,
            user_id: props.UserReducer.user_id,
            influencer_id: props.UserReducer.influencer_id
          });

        if (getPlanDetails.status === gtUtil.Constants.SUCCESS) {
          props.SubscriptionDetail(getPlanDetails.data.rows[0]);
        }
      } catch (error) {
        throw new Error(
          `getSubsctiption Detail in Subscription Influencer :: ${JSON.stringify(
            error
          )}`
        );
      }
    }

    async function getActivePlan() {
      try {
        const response: any =
          await subscriptionService.getSubscription_Remaining_Days({
            user_id: user_id,
            account_id: account_id,
            influencer_id: influencer_id
          });
        if (response.status === gtUtil.Constants.SUCCESS) {
          setActivePlan(response.data.rows[0]);
        } else {
          setActivePlan(null);
        }
      } catch (error) {
        console.log(
          `getActivePlan error in influencer Section :: ${JSON.stringify(
            error
          )}`
        );
      }
    }
    getActivePlan();
    getSubs();
  }, [props.UserReducer]);

  useEffect(() => {
    getSubscriptionDetail();
  }, [getSubscriptionDetail]);

  // For subscription payment
  // coupon_code (optional) → a validated special coupon. When present, the
  // purchase is forced through the ONE-TIME discounted order path (not autopay),
  // and the backend recomputes the chargeable amount server-side.
  const makePayment = async (data: any, coupon_code: string = '') => {
    // Your makePayment function logic here
    setLoading(true);
    setLoadingPlanId(data.plan_id);
    try {
      // const paymentResponse = await makeRazorpayPayment(data, props, razorpay);
      // const paymentResponse = await makeRazorpayPayment(data, props);
      let paymentResponse: any;
      if (coupon_code) {
        // Coupon purchases are always one-time discounted yearly orders.
        paymentResponse = await makeRazorpayPayment(data, props, coupon_code);
      } else if (['Brand', 'Agency'].includes(props.UserReducer?.account_type)) {
        // OLD: paymentResponse = await makeRazorpayPayment(data, props);
        // Brand plans auto-renew now (Razorpay autopay), as creators' plans.
        paymentResponse = await makeBrandSubscriptionPayment(data, props);
      } else {
        paymentResponse = await makeRazorpayAutoPay(data, props);
      }
      if (paymentResponse?.status && (paymentResponse?.paymentId || paymentResponse?.razorpaySubscriptionId)) {
        // Payment successful, perform necessary actions
        // Same staleness applies after a purchase: the header badge is fetched
        // independently and would otherwise lag behind the new plan.
        notifySubscriptionChanged();
        if (['Brand', 'Agency'].includes(props.UserReducer?.account_type)) {
          if (paymentResponse?.razorpaySubscriptionId) {
            navigate(`/brand/orders/confirmed?payment_id=${paymentResponse?.paymentId}&razorpay_subscription_id=${paymentResponse?.razorpaySubscriptionId}`);
          } else if (paymentResponse?.paymentId) {
            navigate(`/brand/orders/confirmed?payment_id=${paymentResponse?.paymentId}`);
          } else {
            console.log("Payment failed");
          }
        } else if (paymentResponse?.razorpaySubscriptionId) {
          navigate(`/influencer/orders/confirmed?payment_id=${paymentResponse?.paymentId}&razorpay_subscription_id=${paymentResponse?.razorpaySubscriptionId}`);
        } else {
          if (paymentResponse?.paymentId) {
            navigate(`/influencer/orders/confirmed?payment_id=${paymentResponse?.paymentId}`);
          } else {
            console.log("Payment failed");
          }
        }
      } else {
        // Payment failed, handle it
        console.log("Payment failed");
        // localService.toastify(paymentResponse?.message, "error", 1000);
      }
    } catch (error) {
      console.error(`Make Payment Error :: ${JSON.stringify(error)}`);
    } finally {
      setLoading(false);
      setLoadingPlanId(null);
    }
  }

  const uniquePlanTypes = useMemo<string[]>(() => {
    return Array.from(
      new Set(availablePlan?.map((plan: any) => plan.plan_type))
    );
  }, [availablePlan]);

  // ---- 7-day free trial ----
  // Claiming writes a zero-amount subscription row server-side; there is no
  // payment step, so we just refetch afterwards and every plan/entitlement in
  // the app flips to premium on the next render.
  const claimTrial = async () => {
    const { user_id, account_id, influencer_id } = props.UserReducer;
    setTrialLoading(true);
    try {
      const response: any = await subscriptionService.claimTrial({
        user_id, account_id, influencer_id,
      });
      if (response.status === gtUtil.Constants.SUCCESS) {
        localService.toastify(response.info || 'Your free trial has started!', 'success', 2000);
        getSubscriptionDetail();
        // Refresh this page's own cards AND the header badge. The header owns a
        // separate fetch keyed on UserReducer, which a plan change doesn't
        // touch, so it needs telling explicitly — otherwise it keeps showing
        // "Upgrade" until the next navigation.
        notifySubscriptionChanged();
      } else {
        localService.toastify(response.info || 'Could not start your free trial.', 'error', 2000);
      }
    } catch (error) {
      localService.toastify('Could not start your free trial. Please try again.', 'error', 2000);
    } finally {
      setTrialLoading(false);
    }
  };

  // Show the Trial card only when it is actually on offer or currently running.
  // Once used up (or while a paid plan is active) it would just be dead space.
  const visiblePlans = useMemo<any[]>(() => {
    return (availablePlan ?? []).filter((plan: any) => {
      if (plan.plan_name !== 'Trial') return true;
      // trial_state_known = 0 → no influencer context; keep it as an advert.
      if (Number(plan.trial_state_known) !== 1) return true;
      return Number(plan.trial_eligible) === 1 || Number(plan.trial_active) === 1;
    });
  }, [availablePlan]);

  return (
    <Fragment>
      <div className='list-section-content rounded'>
        <div className='row align-items-center'>
          <strong className='col'>Subscription</strong>
          {(props.UserReducer.agency_account_id || props.UserReducer.account_type === 'Agency') && props.UserReducer.brand_id && (
            <span>On Behalf of Brand: <strong>{props.UserReducer.brand_name}</strong></span>
          )}
          {props.UserReducer.account_type === 'Talent Partner' && props.UserReducer.influencer_type === 'Talent Partner' && (
            <span>On Behalf of Influencer: <strong>{props.UserReducer.name}</strong></span>
          )}
        </div>
      </div>
      <main className='full-width pb-3 page-pricing'>
        <div className='pricing-tab p-0'>
          {
            planType && planType === 'Half-Yearly' && 
            <span>
              📢 Important Update: Our <strong>half-yearly</strong> subscription plan will be discontinued from <strong>1st November, 2024</strong>. Grab it before it's gone!
            </span>
          }
          {/* <span className={`plan-switch-btns mt-4 ${props.UserReducer.account_type === 'Influencer' ? "d-none": ""}`}>
            <div className='sidebar-nav mb-0'>
              {uniquePlanTypes?.map((type: string) => (
                <span
                  key={type}
                  className={`sidebar-nav-link sml ${
                    planType === type ? "active" : ""
                  }`}
                  onClick={() => handlePlanType(type)}
                >
                  {type}
                </span>
              ))}
            </div>
          </span> */}
          <div className='tab-content' id='pricingTabContent'>
            <div className='pricing-sec-infl'>
              <div className='pricing-sec-right'>
                <div className='pricing-plan-sec'>
                  <div className='pricing-plan-inner'>
                    {/* {
                      (basicPlan && props.UserReducer.account_type !=="Influencer") &&
                      (
                        <PricingPlan
                          key={basicPlan.id}
                          subscription_plan={basicPlan}
                          account_type={props.UserReducer.account_type}
                        />
                      )
                    } */}
                  
                    {/* {
                      availablePlan &&
                      (
                        <Fragment>
                          {availablePlan.map((data: any, index: number) => {
                            
                            if (planType === data.plan_type) {
                              return (
                                <PricingPlan
                                  key={data.id}
                                  subscription_plan={data}
                                  makePayment={makePayment} // Pass makePayment function as prop
                                  loading={loading} // Pass loading state as prop
                                  account_type={props.UserReducer.account_type}
                                  activePlan={activePlan}
                                  availablePlan={availablePlan}
                                />
                              );
                            }
                            return null;
                          })}
                        </Fragment>
                      )
                    } */}
                    {/* OLD: availablePlan?.map(...) — now visiblePlans, which
                        drops the Trial card once it is used up / not on offer. */}
                    {visiblePlans?.map((data: any) => (
                      <PricingPlan
                        key={data.id}
                        subscription_plan={data}
                        makePayment={makePayment}
                        loading={loadingPlanId === data.plan_id}
                        account_type={props.UserReducer.account_type}
                        activePlan={activePlan}
                        availablePlan={availablePlan}
                        influencerId={props.UserReducer.influencer_id}
                        isUSInfluencer={isUSInfluencer}
                        claimTrial={claimTrial}
                        trialLoading={trialLoading}
                      />
                    ))}
                  </div>
                    {/* A Talent Partner's creator reads it too (same rules as any creator). */}
                    {['Influencer', 'Talent Partner'].includes(props.UserReducer.account_type) &&
      <p className="fs-14 font-italic pb-5"><strong>Please note:</strong> ClanConnect is an influencer marketplace where we bring influencers and brands on a common plane in the most transparent manner. The selection of influencers for campaigns is the sole prerogative of the brand and ClanConnect has no role in this. Also, it is advisable to have a minimum of 1000 followers/subscribers to apply for a campaign.</p>
      }
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </Fragment>
  );
};

const mapStateToProps = (state: any) => {
  return {
    UserReducer: state.UserReducer.UserData,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    SubscriptionDetail: (data: any) => dispatch(SubscriptionDetail(data)),
  };
};

const connectToRedux = connect(
  mapStateToProps,
  mapDispatchToProps
)(UserSubscription);

export { connectToRedux as UserSubscription };
